//
// DataAnimationController.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import ClosetObject from "@sas-dvr/ltjs-commons/ClosetObject";
import "../../../lib";

var DataAnimationController = createModule("gtl::DataAnimationController", [], ClosetObject, [
    ,
    ,
    ,
    ,
    {
        play: [0],
        getOrderedKeyframeValues: [[7]],
        setCurrentKeyframeValue: [0,7],
        stepForward: [0],
        stepReverse: [0],
        pause: [0],
    },
    ,
    ,
]);
export default DataAnimationController;
